export default "__VITE_ASSET__192ab8b2__"